import { parseDisplayLocales } from '@/i18n/display-locales';
import { APP_CONFIG_KEY, type AppConfig } from '@/types/AppConfig.type';
import { systemConfig } from '@/config/systemConfig';

function readLocalDisplayLocalesOverride(): string[] | undefined {
  if (!systemConfig.isLocal) {
    return undefined;
  }
  const raw = __INSPECT_DISPLAY_LOCALES_OVERRIDE__.trim();
  if (!raw) {
    return undefined;
  }
  const locales = raw
    .split(',')
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0);
  return locales.length > 0 ? locales : undefined;
}

function readLocalEnableDisplayLanguagesOverride(): boolean | undefined {
  if (!systemConfig.isLocal) {
    return undefined;
  }
  const raw = __INSPECT_ENABLE_DISPLAY_LANGUAGES_OVERRIDE__.trim().toLowerCase();
  if (!raw) {
    return undefined;
  }
  if (raw === 'true' || raw === '1') {
    return true;
  }
  if (raw === 'false' || raw === '0') {
    return false;
  }
  return undefined;
}

/** Applies LOCAL_DEV overrides and normalises display-language settings after clivconfig fetch. */
export function applyInspectConfigOverrides(config: AppConfig): AppConfig {
  const localesOverride = readLocalDisplayLocalesOverride();
  const enableOverride = readLocalEnableDisplayLanguagesOverride();
  const translationsEnabled =
    enableOverride ?? (localesOverride ? true : config[APP_CONFIG_KEY.enableDisplayLanguages]);
  const localesSource = localesOverride ?? config[APP_CONFIG_KEY.displayLocales];
  const next: AppConfig = { ...config };
  if (enableOverride !== undefined || localesOverride) {
    next[APP_CONFIG_KEY.enableDisplayLanguages] = translationsEnabled === true;
  }
  if (localesSource) {
    next[APP_CONFIG_KEY.displayLocales] = parseDisplayLocales(localesSource);
  }
  return next;
}
